var map = {
	"./IMG_20210715_0001.jpg": 4013,
	"./IMG_20210715_0002.jpg": 2925,
	"./KORICA TRAKIA 3.jpg": 9394,
	"./KORICATA TРАКИЯ 3 big.jpg": 2947,
	"./balkanskata-liniq.jpg": 1343,
	"./kniga-kristina-bovanowa.jpg": 4546,
	"./knigi-na-predsedatelq.jpg": 1891,
	"./stariqt-litglas.jpg": 4741,
	"./westnik-litglas.jpg": 837,
	"./wsichki-sytrudnici.jpg": 4460,
	"./zaglavka.jpg": 930
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4528;